import { gql } from "@apollo/client";
// import { users_query } from "./quires";

let users_query = gql`
  query UsersSearch($keyword: String) {
    UsersSearch(keyword: $keyword) {
      _id
      UserName
      Full_Name
      Search_Value
    }
  }
`;

const Task_Inputs = [
  {
    id: Math.random() * 10,
    name: "Task_Details",
    fields: [
      // {
      //   id: Math.random() * 10,
      //   name: "Title",
      //   label: "Title",
      //   type: "text",
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "Description",
      //   label: "Description",
      //   type: "textarea",
      // },
      {
        id: Math.random() * 10,
        name: "Assignee",
        label: "Assignee",
        type: "InputDropForQuery",
        masterName: "User_Entry",
        // dropdowncontent: users_query,
      },
      {
        id: Math.random() * 10,
        name: "Reporter",
        label: "Reporter",
        type: "InputDropForQuery",
        masterName: "User_Entry",
        // dropdowncontent: users_query,
      },
      {
        id: Math.random() * 10,
        name: "Priority",
        label: "Priority",
        type: "inputdrop",
        dropdowncontent: ["Heighest", "High", "Medium", "Low", "Lowest"],
      },
      {
        id: Math.random() * 10,
        name: "Start_Date",
        label: "Start Date",
        type: "Date",
      },
      {
        id: Math.random() * 10,
        name: "Due_Date",
        label: "Due Date",
        type: "Date",
      },
      {
        id: Math.random() * 10,
        name: "Title",
        label: "Title",
        type: "textarea",
      },
    ],
  },
];

export { Task_Inputs };
